import Event from '../../data/models/Event'


export default ({ highlightedEvent }) => ({
  __typename: 'HighlightedEventWrapper',
  ...highlightedEvent && {
    highlightedEvent: Event(highlightedEvent),
  },
})
